export function HowToClaim() {
  return (
    <div className="bg-white">
      <div className="mx-auto max-w-md bg-white">
        <div className="px-4 py-3 space-y-6">
          <h1 className="text-[32px] font-bold text-gray-900 text-center">
            How It Works
          </h1>

          <div className="border-[#00000033] border px-6 py-10 space-y-4">
            <img
              src="/images/scan-nfc.png"
              alt="Tap"
              className="mx-auto max-w-[240px]"
            />

            <h2 className="text-2xl font-bold">Tap</h2>

            <p className="text-xl">
              Tap the <strong>NFC</strong> chip with your phone to get started.
            </p>
          </div>

          <div className="border-[#00000033] border px-6 py-10 space-y-4">
            <img
              src="/images/receive-nfc.png"
              alt="Receive"
              className="mx-auto max-w-[240px]"
            />

            <h2 className="text-2xl font-bold">Receive</h2>

            <p className="text-xl">
              Your exclusive Digital Collectible will be delivered instantly to
              your wallet.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
